import { rest } from 'services'
import { getShoppingData } from 'actions/shoppingData'
import { googleAnalyticCheckout } from 'actions/googleAnalytic'

export const updateProductOTDPAddons = payload => dispatch =>
  dispatch(getShoppingData(rest.api.updateProduct, payload)).then(() => dispatch(googleAnalyticCheckout()))
